import React from 'react';
import { Award } from 'lucide-react';
export function BrochureHero() {
  return <div className="relative bg-navy text-white page-break-inside-avoid" data-id="element-1">
      {/* Simplified background pattern for print */}
      <div className="absolute inset-0 opacity-5" data-id="element-2">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-3">
          <path d="M0 100 Q 50 20 100 100" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-4" />
          <path d="M0 100 Q 50 30 100 100" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-5" />
          <line x1="20" y1="100" x2="20" y2="60" stroke="currentColor" strokeWidth="0.5" data-id="element-6" />
          <line x1="80" y1="100" x2="80" y2="60" stroke="currentColor" strokeWidth="0.5" data-id="element-7" />
        </svg>
      </div>

      <div className="container mx-auto px-8 py-16 relative z-10" data-id="element-8">
        <div className="text-center max-w-4xl mx-auto" data-id="element-9">
          <div className="mb-6 inline-flex p-4 rounded-full bg-white/10 border border-gold/30" data-id="element-10">
            <Award className="w-12 h-12 text-gold" data-id="element-11" />
          </div>

          <h1 className="text-5xl md:text-6xl font-bold mb-4 tracking-tight font-serif" data-id="element-12">
            TVET Services & Skills Transformation
          </h1>

          <div className="text-2xl text-gold italic font-serif mb-6" data-id="element-13">
            Strengthening TVET Systems for Quality, Relevance, and Global
            Recognition
          </div>

          <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-14">
            London Bridge for Academic Services (LBAS) provides comprehensive
            Technical and Vocational Education and Training (TVET) services
            designed to enhance quality, relevance, and international alignment
            across all TVET levels.
          </p>

          <div className="mt-8 p-6 bg-white/5 border border-white/10 text-left" data-id="element-15">
            <p className="text-gray-300 leading-relaxed" data-id="element-16">
              We support TVET providers, ministries, accreditation bodies, and
              employers in modernising systems, programmes, and delivery models
              to meet labour-market demands, green transition priorities, and
              digital transformation agendas.
            </p>
          </div>
        </div>
      </div>
    </div>;
}